import Group from "../Group";

const groupLatestLanguageCodeKey = "groupLatestLanguageCodeKey";
const groupLatestSaveGroupKey = "groupLatestSaveGroupKey";

export function initializeGroupSettings() {
  localStorage.removeItem(groupLatestLanguageCodeKey);
  localStorage.removeItem(groupLatestSaveGroupKey);
}

export function getGroupLatestLanguageCode(): string | null {
  return localStorage.getItem(groupLatestLanguageCodeKey);
}

export function setGroupLatestLanguageCode(code: string) {
  localStorage.setItem(groupLatestLanguageCodeKey, code);
}

export function getLatestSaveGroup(): Group | null {
  const stored = localStorage.getItem(groupLatestSaveGroupKey);
  if (stored !== null) {
    return JSON.parse(stored);
  }
  return null;
}

export function setLatestSaveGroup(group: Group) {
  localStorage.setItem(groupLatestSaveGroupKey, JSON.stringify(group));
}
